var _tspan, _tspan2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.92 30.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 10.32)",
    style: {
      fontSize: 12,
      fontFamily: "Helvetica-Bold, Helvetica",
      fontWeight: 700
    }
  }, "Marcell", /*#__PURE__*/React.createElement("tspan", {
    x: 41.36,
    y: 0,
    style: {
      letterSpacing: "-0.03662109375em"
    }
  }, "\u2019"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 44.25,
    y: 0
  }, "s")), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14.4,
    style: {
      letterSpacing: "-0.017578125em"
    }
  }, "W"), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 11.12,
    y: 14.4
  }, "ebsite"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fba878ea79eb6c9b4347572265a797b2.svg";
export { ForwardRef as ReactComponent };